import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import io from 'socket.io-client';
import Cookies from 'js-cookie';
import { viewAllRecord, deleteRecord } from '../../services/areaOfLawServives';

function AreaOfLaw(props) {
  const [areaOfLaw, setAreaOfLaw] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL_DOCUMENT;

  useEffect(() => {
    async function clientSocket() {
      const socket = io(baseURL);

      // Socket for getting area of law record
      socket.on('areaOfLaw', (ms) => {
        getAll();
      });
    }
    clientSocket();
    getAll();
  }, []);

  async function getAll() {
    viewAllRecord()
      .then((response) => {
        setAreaOfLaw(response.data);
      })
      .catch((error) => {
        if (error.response.data.userError) {
          Cookies.remove('token');
          Cookies.remove('creadUseDetail');
          props.history.push('/');
          window.location.reload();
        }
      });
  }

  async function deleteData(id) {
    if (
      window.confirm('Are you sure you want to delete this area of law record?')
    ) {
      deleteRecord(id)
        .then((response) => {
          const socket = io(baseURL);
          const userId = Cookies.get('creadUseDetail');
          socket.emit('areaOfLaw', `${userId}`);
          socket.emit('deleteAreaOfLaw', `${id}`);
        })
        .catch((error) => {
          if (error.response.data.userError) {
            Cookies.remove('token');
            Cookies.remove('creadUseDetail');
            props.history.push('/');
            window.location.reload();
          }
        });
    }
  }

  return (
    <div className="col-md-6 col-12">
      <div className="card">
        {/* /.card-header */}
        <div className="card-body">
          <table id="example2" className="table table-bordered table-hover">
            <thead className="headerTable">
              <tr>
                <th>Name</th>
                <th colSpan="2" className="col-span">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {areaOfLaw.map((detail) => (
                <tr key={detail._id}>
                  <td>{detail.name}</td>
                  <td className="col-span">
                    <Link
                      className="btn btn-primary mr-2"
                      to={{ pathname: `/cms-area-of-law-edit/${detail._id}` }}
                      onClick={() => {
                        window.location.href = `/cms-area-of-law-edit/${detail._id}`;
                      }}
                    >
                      Edit
                    </Link>
                  </td>
                  <td className="col-span">
                    <Link
                      to="#"
                      onClick={() => deleteData(detail._id)}
                      className="btn btn-danger mr-2 disabled-lin"
                    >
                      Delete
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* /.card-body */}
      </div>
      {/* /.card */}
      {/* /.card */}
    </div>
  );
}

export default withRouter(AreaOfLaw);
